var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mb-0 mt-2",attrs:{"no-body":""}},[(false)?_c('patient-tab-reminder-table'):_vm._e(),_c('patient-tab-reminder-add')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }